import { render, staticRenderFns } from "./BrandButton.vue?vue&type=template&id=50832719&scoped=true"
import script from "./BrandButton.vue?vue&type=script&lang=js"
export * from "./BrandButton.vue?vue&type=script&lang=js"
import style0 from "./BrandButton.vue?vue&type=style&index=0&id=50832719&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50832719",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50832719')) {
      api.createRecord('50832719', component.options)
    } else {
      api.reload('50832719', component.options)
    }
    module.hot.accept("./BrandButton.vue?vue&type=template&id=50832719&scoped=true", function () {
      api.rerender('50832719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrandButton.vue"
export default component.exports